import TopicsTagAssignment from "./js/TopicsTagAssignment";

export default TopicsTagAssignment;
